"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ARArrowIcon = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("@emotion/react");
const ARArrowIcon = (_a) => {
    var { color } = _a, props = __rest(_a, ["color"]);
    const theme = (0, react_1.useTheme)();
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { fill: color !== null && color !== void 0 ? color : theme.colors.grey90, fillRule: "evenodd", clipRule: "evenodd", d: "M2.18 3.35234C2.04484 2.65651 2.65651 2.04484 3.35234 2.18L17.6634 4.95994C18.4499 5.11272 18.7464 6.08216 18.1798 6.6487L15.9498 8.87872L21.6067 14.5356C21.9972 14.9261 21.9972 15.5593 21.6067 15.9498L15.9498 21.6066C15.5593 21.9972 14.9261 21.9972 14.5356 21.6066L8.87875 15.9498L6.64865 18.1799C6.08211 18.7464 5.11267 18.45 4.95989 17.6635L2.18 3.35234ZM4.63611 4.63608L15.2867 6.71343L13.1214 8.87872L19.4853 15.2427L15.2427 19.4853L8.87875 13.1214L6.71346 15.2866L4.63611 4.63608Z" }) })));
};
exports.ARArrowIcon = ARArrowIcon;
//# sourceMappingURL=ar_arrow_icon.js.map